module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "winner",
    staticClass: "winner"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "loader": "dots",
      "color": "#1f9ed3",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current-info"
  }, [_c('h4', [_vm._v("Tuần số: "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.times))])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticketid))])]), _vm._v(" "), (_vm.ticket && _vm.ticket.length > 1) ? _c('div', {
    staticClass: "last-info"
  }, [_c('h4', [_vm._v("Tuần mở thưởng trước: Tuần số "), _c('span', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.ticket && _vm.ticket[1].issue || 'xx') + " ")])]), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("Mã dự thưởng của bạn:")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-info"
  }, [_vm._v(_vm._s(_vm.ticket && _vm.ticket[1].lottery || 'xxxxxx'))]), _vm._v(" "), _c('h4', {
    staticClass: "info"
  }, [_vm._v("Tình trạng giải thưởng:")]), _vm._v(" "), _c('div', {
    staticClass: "win-status"
  }, [_vm._v(_vm._s(_vm.ticket.status === 0 ? "Không trúng thưởng" : "Không trúng thưởng"))])]) : _c('div', {
    staticClass: "last-info"
  }, [_vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Tuần mở thưởng trước: "), _c('span', {
    staticClass: "times"
  }, [_vm._v("Không tham gia")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1409fdf1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WinRecord.vue
// module id = 983
// module chunks = 1